import { useState, useEffect, useRef, useCallback } from "react";
import {
  Row,
  Col,
  Button,
  Modal,
  Radio,
  Spin,
  Form,
  Space,
  Card,
  Input,
  message,
  Badge,
  Popover,
  Alert,
  ColorPicker,
  Slider,
  InputNumber,
  Divider,
} from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";
import { lazy } from "react";
import { Suspense } from "react";
import { EyeOutlined, SaveOutlined } from "@ant-design/icons";
import BlogModal from "./components/BlogModal";
import { CardSortableItem } from "./dndComponent/CardSortableItem";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import update from "immutability-helper";
import BlogForm from "./components/BlogForm";

const PageSetting = ({ prefixTitle = "" }) => {
  const { permissionName } = useParams();
  const [permissionId, setPermissionId] = useState(null);
  const [componentData, setComponentData] = useState([]);
  const [pageContainerData, setPageContainerData] = useState([]);
  const [classifyStructureTypeId, setClassifyStructureTypeId] = useState([]);
  const [colorPicker, setColorPicker] = useState();
  const [fontSizeSlider, setFontSizeSlider] = useState(5);

  const componentRender = (component_name, blogTypeData) => {
    const Component = lazy(() => import(`./components/${component_name}`));
    // console.log(blogTypeData)
    if (blogTypeData.length !== 0) {
      return (
        <Suspense fallback={<></>}>
          <Component blogTypeData={blogTypeData} edit={true} />
        </Suspense>
      );
    } else {
      return (
        <Suspense fallback={<></>}>
          <Component
          // blogTypeData={blogTypeData}
          />
        </Suspense>
      );
    }
  };

  const addContainer = (component_id, component_name, rowIndex) => {
    setPageContainerData((prev) => {
      return [
        ...prev,
        {
          frontend_row_index: prev.length + 1,
          permission_frontend_row_data: [
            {
              frontend_column_index: 1,
              frontend_row_frontend_column_data: [
                {
                  frontend_component_id: component_id,
                  frontend_component_name: component_name,
                  frontend_column_frontend_component_blog_type_data: [],
                },
              ],
            },
          ],
        },
      ];
    }, message.success("新增成功"));
  };
  const changeRowDataIndex = () => {
    // let rowData = [...rowData_]
    // console.log(pageContainerData)
    setPageContainerData((prev) => {
      // console.log(prev)
      return [
        ...prev.map((map_item, map_index) => {
          return {
            ...map_item,
            frontend_row_index: map_index + 1,
          };
        }),
      ];
      // ...prev,
    });
    savePageContainerData();
  };
  const savePageContainerData = () => {
    // changeRowDataIndex()
    axios
      .patch(`/dynamicWebsite/backend/permission`, {
        classify_structure_id: 5,
        classify_structure_type_id: classifyStructureTypeId,
        permission_id: permissionId,
        name: permissionName,
        frontend_column_frontend_component_blog_type_data: pageContainerData,
      })
      .then((response) => {
        if (response.data?.status === "success") {
          message.success("儲存成功");
        } else {
          message.error("儲存失敗");
        }
      })
      .catch((error) => {
        message.error("儲存失敗");
      });
  };

  const patchPageContainerData = (data, rowIndex) => {
    setPageContainerData((prev) => {
      return findRowData("patch", prev, rowIndex, data);
    });
  };
  const deletePageContainerData = (rowIndex) => {
    // console.log(rowIndex)
    setPageContainerData((prev) => {
      // console(findRowData('delete', prev, rowIndex))
      return findRowData("delete", prev, rowIndex);
    });
    // console.log(pageContainerData)
  };
  const findRowData = (type, rowData_, rowIndex, data) => {
    // console.log(data)
    let rowData = [...rowData_];
    if (type === "delete") {
      rowData = [
        ...rowData.filter((map_item, map_index) => {
          if (map_index + 1 !== rowIndex) {
            return map_item;
          }
        }),
      ];
      rowData.map((map_item, map_index) => {
        return {
          ...map_item,
          frontend_row_index: map_index + 1,
        };
      });
    } else if (type === "patch") {
      rowData = [
        ...rowData.map((map_item, map_index) => {
          // console.log(map_item)

          if (map_index + 1 === rowIndex) {
            return {
              ...map_item,
              permission_frontend_row_data:
                map_item?.permission_frontend_row_data?.map(
                  (columnData, columnIndex) => {
                    return {
                      ...columnData,
                      frontend_row_frontend_column_data:
                        columnData?.frontend_row_frontend_column_data?.map(
                          (componentData, componentIndex) => {
                            return {
                              ...componentData,
                              frontend_column_frontend_component_blog_type_data:
                                data,
                            };
                          }
                        ),
                    };
                  }
                ),
            };
          } else {
            return map_item;
          }
        }),
      ];
    }
    return rowData;
  };
  useEffect(() => {}, [pageContainerData]);

  useEffect(() => {
    // console.log(permissionName)
    if (permissionName) {
      document.title = `${prefixTitle} | 頁面編排`;

      axios
        .get(`/dynamicWebsite/backend/permission`, {
          params: {
            classify_structure_id: 5,
            name: permissionName,
            cur_page: 1,
            size: 10,
          },
        })
        .then((response) => {
          if (response?.data.data.length !== 0) {
            let data = response.data?.data;
            let firstData = data.find((_) => true);
            let permission_id = firstData?.permission_id;
            let classify_structure_type_id =
              firstData?.classify_structure_type_parent_id;
            let frontend_component_blog_type_data =
              firstData?.frontend_component_blog_type_data;
            // console.log(response?.data.data)
            setClassifyStructureTypeId(classify_structure_type_id);
            setPermissionId(permission_id);
            setPageContainerData(frontend_component_blog_type_data);
            // get_picture(response.data.data);
          }
        });

      axios
        .get(`/dynamicWebsite/frontend/frontend_component`, {
          // params: {
          //     classify_structure_id: 5,
          //     name: permissionName,
          //     cur_page: 1,
          //     size: 10,
          // }
        })

        .then((response) => {
          if (response?.data.data.length !== 0) {
            // console.log(response?.data.data)
            setComponentData(response?.data.data);
          }
        });
    }
  }, [permissionName]);

  useEffect(() => {
    setPageContainerData((prev) => {
      // console(findRowData('delete', prev, rowIndex))
      return prev.map((map_item) => ({
        ...map_item,
        permission_frontend_row_data:
          map_item?.permission_frontend_row_data?.map(
            (columnData, columnIndex) => {
              return {
                ...columnData,
                frontend_row_frontend_column_data:
                  columnData?.frontend_row_frontend_column_data?.map(
                    (componentData, componentIndex) => {
                      return {
                        ...componentData,
                        frontend_column_frontend_component_blog_type_data:
                          componentData.frontend_column_frontend_component_blog_type_data?.map(
                            (blogTypeData, componentIndex) => {
                              return {
                                ...blogTypeData,
                                frontend_column_frontend_component_blog_type_blog_data:
                                  blogTypeData?.frontend_column_frontend_component_blog_type_blog_data?.map(
                                    (blogTypeBlogData, componentIndex) => {
                                      return {
                                        ...blogTypeBlogData,
                                        property_json: {
                                          ...blogTypeData.property_json,
                                          fontSizeScale: (
                                            0.5 +
                                            0.1 * fontSizeSlider
                                          ).toFixed(1),
                                          color: colorPicker,
                                        },
                                      };
                                    }
                                  ),
                              };
                            }
                          ),
                      };
                    }
                  ),
              };
            }
          ),
      }));
    });
  }, [fontSizeSlider, colorPicker]);
  useEffect(() => {
    let temp = [
      {
        frontend_component_id: 2,
        frontend_component_name: "InteractableBanner",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: false,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 5,
        frontend_component_name: "Banner",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: false,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 9,
        frontend_component_name: "HorizentalCard",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: true,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: true,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 12,
        frontend_component_name: "HoverReveal",
        frontend_component_name_client: "方塊圖片標題",
        frontend_component_note: "移動呈現詳細資訊",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: true,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 14,
        frontend_component_name: "PhotoCard",
        frontend_component_name_client: "圖文樣式",
        frontend_component_note: "圖片文字說明",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: true,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: true,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 17,
        frontend_component_name: "PhotoCarousel",
        frontend_component_name_client: "圖片輪播",
        frontend_component_note: "圖片標題輪播",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: true,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 18,
        frontend_component_name: "Service",
        frontend_component_name_client: "圖文樣式",
        frontend_component_note: "圖片、文字標題說明",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: true,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 19,
        frontend_component_name: "ScrollIcon",
        frontend_component_name_client: "圖片輪播",
        frontend_component_note: "純圖片輪播",
        property_json: {
          show: {
            title: false,
            content: false,
            more_content: false,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 20,
        frontend_component_name: "ProjectResult",
        frontend_component_name_client: "圖文樣式",
        frontend_component_note: "圖文上下交叉呈現",
        property_json: {
          show: {
            title: true,
            content: false,
            more_content: true,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: true,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 21,
        frontend_component_name: "Video",
        frontend_component_name_client: "youtube影片嵌入",
        frontend_component_note: "youtube影片嵌入",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: true,
            external_link: true,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: true,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 22,
        frontend_component_name: "Streaming",
        frontend_component_name_client: "線上直播",
        frontend_component_note: "線上直播",
        property_json: {
          show: {
            title: true,
            content: true,
            more_content: true,
            external_link: true,
            blog_news_data: true,
            blog_room_data: true,
            youtube_iframe: true,
            extermal_link_check: true,
            blog_type_classify_structure_type_blog_data: true,
          },
        },
      },
      {
        frontend_component_id: 23,
        frontend_component_name: "WYSIWYG",
        frontend_component_name_client: "所見即所得",
        frontend_component_note: "所見即所得",
        property_json: {
          show: {
            title: true,
            content: false,
            more_content: true,
            external_link: false,
            blog_news_data: false,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: false,
            blog_type_classify_structure_type_blog_data: false,
          },
        },
      },
      {
        frontend_component_id: 27,
        frontend_component_name: "News",
        frontend_component_name_client: "最新消息",
        frontend_component_note: "最新消息",
        property_json: {
          show: {
            title: false,
            content: false,
            more_content: false,
            external_link: false,
            blog_news_data: true,
            blog_room_data: false,
            youtube_iframe: false,
            extermal_link_check: false,
            blog_type_classify_structure_type_blog_data: false,
          },
        },
      },
    ];
    temp = temp.map((value) => {
      return {
        ...value,
        property_json: JSON.stringify(value?.property_json),
      };
    });
    console.log(temp);
  }, []);
  return (
    <Row gutter={[10, 20]} justify="space-around" style={{ padding: "10px" }}>
      <Col lg={{ span: 4 }} sm={{ span: 4 }} xs={{ span: 24 }}>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Popover
              placement={"rightBottom"}
              trigger={"click"}
              content={
                <>
                  <Badge.Ribbon text="模板庫" color="cyan">
                    <Card title="貼文樣式">
                      {componentData.map((component, componentIndex) => {
                        return (
                          <Card.Grid
                            style={{
                              textAlign: "center",
                            }}
                            onClick={(e) => {
                              addContainer(
                                component.frontend_component_id,
                                component.frontend_component_name
                              );
                            }}
                          >
                            <p>【{componentIndex + 1}】</p>
                            <p>
                              【{component.frontend_component_name_client}】
                            </p>
                            <p>【{component.frontend_component_name}】</p>
                            <p>{component.frontend_component_note}</p>
                          </Card.Grid>
                        );
                      })}
                    </Card>
                  </Badge.Ribbon>
                </>
              }
            >
              <Button block type="primary">
                新增單一區塊
              </Button>
            </Popover>
          </Col>
          <Col span={24}>
            <Popover
              placement={"left"}
              trigger={"click"}
            //   overlayStyle={{
            //     width: "90vw",
            //   }}
              content={
                <>
                  <CardSortable
                    propsData={pageContainerData}
                    setPropsData={setPageContainerData}
                  />
                </>
              }
            >
              <Button block type="primary">
                修改區塊順序
              </Button>
            </Popover>
          </Col>
          <Col span={24}>
            <Popover
              placement={"rightBottom"}
              trigger={"click"}
              content={
                <>
                  <Card title="修改區塊文字屬性">
                    <Row>
                      <Col span={24}>
                        <ColorPicker
                          showText
                          onChange={(_, color) => {
                            // console.log(color)
                            setColorPicker(color);
                          }}
                        />
                      </Col>
                      <Col span={24}>
                        <SliderFontSize
                          fontSizeSlider={fontSizeSlider}
                          setFontSizeSlider={setFontSizeSlider}
                        />
                      </Col>
                    </Row>
                  </Card>
                </>
              }
            >
              <Button block type="primary">
                修改區塊文字屬性
              </Button>
            </Popover>
          </Col>
        </Row>
      </Col>
      <Col lg={{ span: 20 }} sm={{ span: 20 }} xs={{ span: 24 }}>
        <Card
          title="頁面設計"
          extra={
            <Row gutter={[10, 20]} justify="space-around">
              <Col>
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  size="small"
                  onClick={(e) => {
                    savePageContainerData();
                  }}
                >
                  儲存
                </Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  icon={<EyeOutlined />}
                  size="small"
                  onClick={(e) => {
                    if (permissionName) {
                      // console.log(permissionName)
                      window.open(`/officialweb/frontend/${permissionName}`);
                    }
                  }}
                >
                  預覽
                </Button>
              </Col>
            </Row>
          }
        >
          <Row gutter={[10, 20]} justify="space-around">
            {/* <Space> */}
            {pageContainerData &&
              pageContainerData?.map((rowData, rowIndex) => {
                return rowData?.permission_frontend_row_data?.map(
                  (columnData, columnIndex) => {
                    let componentDatas = componentData;
                    return columnData?.frontend_row_frontend_column_data?.map(
                      (componentData, componentIndex) => {
                        let frontendComponentId =
                          componentData?.frontend_component_id;
                        let frontendComponentData = componentDatas.find(
                          (element) => {
                            return (
                              element?.frontend_component_id ===
                              frontendComponentId
                            );
                          }
                        );
                        let propertyJson = frontendComponentData?.property_json;
                        let propertyJsonShow = propertyJson?.show;

                        const BlogTypeData = componentData?.frontend_column_frontend_component_blog_type_data.map(
                          (BlogTypeData)=>{
                            return {
                              ...BlogTypeData,
                              frontend_column_frontend_component_blog_type_blog_data:BlogTypeData.frontend_column_frontend_component_blog_type_blog_data.map(
                                (BlogData)=>{
                                  return {
                                    ...BlogData,
                                    extermal_link_check:BlogData.extermal_link_check===1
                                  }
                                }
                              )
                            }
                          }
                        )

                        return (
                          <Col span={24}>
                            <Row gutter={[10, 20]} justify="space-around">
                              {/* <Space> */}
                              <Col span={24}>
                                <Row
                                  justify="left"
                                  id={rowIndex}
                                  key={rowIndex}
                                >
                                  <Space>
                                    <Col>
                                      <BlogModal
                                        data={
                                          BlogTypeData
                                        }
                                        onSuccess={(value) => {
                                          patchPageContainerData(
                                            value,
                                            rowIndex + 1
                                          );
                                        }}
                                        colorPicker={colorPicker}
                                        fontSizeSlider={fontSizeSlider}
                                        frontendComponentId={
                                          componentData?.frontend_component_id
                                        } //確認這次使用的frontendComponent
                                        propertyJsonShow={propertyJsonShow} //確認要顯示的項目 blog form item
                                      ></BlogModal>
                                    </Col>
                                    <Col>
                                      <Button
                                        onClick={(e) => {
                                          deletePageContainerData(rowIndex + 1);
                                        }}
                                      >
                                        刪除區塊
                                      </Button>
                                    </Col>
                                    <Col span={24}>
                                      {/* <Popover
                                                                                placement={'rightBottom'}
                                                                                trigger={'click'}
                                                                                content={<>
                                                                                    <CardSortable
                                                                                        propsData={componentData?.frontend_column_frontend_component_blog_type_data}
                                                                                        setPropsData={(prevPropsData) => console.log(prevPropsData)}
                                                                                    />
                                                                                </>}
                                                                            >
                                                                                <Button block
                                                                                    type="primary"
                                                                                >修改貼文順序</Button>
                                                                            </Popover> */}
                                      <Popover content={<>建置中...</>}>
                                        <Button block type="primary" disabled>
                                          修改貼文順序
                                        </Button>
                                      </Popover>
                                    </Col>
                                    <Col span={24}>
                                      {/* <Popover
                                                                                placement={'rightBottom'}
                                                                                trigger={'click'}
                                                                                content={<>
                                                                                    <Card title="修改區塊文字屬性">
                                                                                        <Row>
                                                                                            <Col span={24}>
                                                                                                <ColorPicker showText />
                                                                                            </Col>
                                                                                            <Col span={24}>
                                                                                                <SliderFontSize />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Card>
                                                                                </>}
                                                                            >
                                                                                <Button block
                                                                                    type="primary"
                                                                                >修改貼文文字屬性</Button>
                                                                            </Popover> */}
                                      <Popover content={<>建置中...</>}>
                                        <Button block type="primary" disabled>
                                          修改貼文文字屬性
                                        </Button>
                                      </Popover>
                                    </Col>
                                  </Space>
                                </Row>
                              </Col>
                              <Col span={24}>
                                {componentRender(
                                  componentData.frontend_component_name,
                                  componentData.frontend_column_frontend_component_blog_type_data
                                )}
                              </Col>
                              {/* </Space> */}
                            </Row>
                          </Col>
                        );
                      }
                    );
                  }
                );
              })}
            {/* </Space> */}
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
export default PageSetting;
const SliderFontSize = ({
  fontSizeSlider = 5,
  setFontSizeSlider = () => {},
}) => {
  const [inputValue, setInputValue] = useState(fontSizeSlider);
  const onChange = (newValue) => {
    setInputValue(newValue);
    setFontSizeSlider(newValue);
  };
  return (
    <>
      <Row>
        <Col span={12}>
          <Slider
            min={1}
            max={10}
            onChange={onChange}
            value={typeof inputValue === "number" ? inputValue : 0}
            tooltip={{ open: false }}
          />
        </Col>
        <Col span={4}>
          <InputNumber
            min={1}
            style={{
              margin: "0 16px",
            }}
            value={(0.5 + inputValue * 0.1).toFixed(1)}
            onChange={onChange}
          />
        </Col>
      </Row>
    </>
  );
};
const CardSortable = ({ propsData = [], setPropsData = () => {} }) => {
  const [data, setData] = useState(propsData);
  const [form] = Form.useForm();

  const moveCard = useCallback((dragIndex, hoverIndex) => {
    setPropsData((prevCards) => {
      const data = update(prevCards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, prevCards[dragIndex]],
        ],
      });
      data &&
        data?.map((rowData, rowIndex) => {
          data[rowIndex].frontend_row_index = rowIndex + 1;

          return rowData;
        });
      return data;
    });
  }, []);
  const renderCard = useCallback((card, rowIndex, onClick) => {
    return (
      <CardSortableItem
        key={card.frontend_row_index}
        index={rowIndex}
        id={card.frontend_row_index}
        text={
          <>
            {
              card.permission_frontend_row_data
                .find((_) => true)
                ?.frontend_row_frontend_column_data?.find((_) => true)
                ?.frontend_column_frontend_component_blog_type_data?.find(
                  (_) => true
                )?.blog_type_name
            }
          </>
        }
        moveCard={moveCard}
        onClick={onClick}
      />
    );
  }, []);
  const renderArtitleCard = (columnData, columnIndex, onClick) => {
    let blogTypeData = [];
    blogTypeData = columnData?.frontend_row_frontend_column_data?.map(
      (componentData, componentIndex) => {
        if (componentIndex === 0) {
          return componentData.frontend_column_frontend_component_blog_type_data?.map(
            (blogTypeData, componentIndex) => {
              return (
                // blogTypeData
                <Card title={blogTypeData.blog_type_name}>
                  {blogTypeData.frontend_column_frontend_component_blog_type_blog_data?.map(
                    (blogData, BlogDataIndex) => {
                      return (
                        <Card.Grid
                          key={blogData.blog_id}
                          onClick={() => onClick(blogData)}
                        >
                          {blogData.title}
                          {/* {console.log("blogData",blogData)} */}
                        </Card.Grid>
                      );
                    }
                  )}
                </Card>
              );
            }
          );
        }
      }
    );

    return blogTypeData;
  };
  const renderBlogData = (rowData, rowDataIndex) => {
    let blogTypeData = [];
    blogTypeData = rowData.permission_frontend_row_data?.map(
      (columnData, columnIndex) => {
        if (columnIndex === 0) {
          columnData.frontend_row_frontend_column_data?.map(
            (componentData, componentIndex) => {
              return componentData.frontend_column_frontend_component_blog_type_data?.map(
                (blogTypeData, componentIndex) => {
                  return (
                    // blogTypeData
                    <>
                      {form.setFieldsValue({ item: blogTypeData })}
                      <BlogForm propsForm={form}></BlogForm>
                    </>
                  );
                }
              );
            }
          );
        }
      }
    );
    return blogTypeData;
  };
  const [columnData, setColumnData] = useState([]);
  const [blogData, setBlogData] = useState([]);

  const rowOnClick = (rowData) => {
    // console.log("rowData", rowData)
    setColumnData(rowData?.permission_frontend_row_data);
  };
  const blogOnClick = (blogData) => {
    setBlogData(blogData);
    form.setFieldsValue({ item: blogData });
  };
  useEffect(() => {
    setData(propsData);
  }, [propsData]);
  return (
    <>
        <DndProvider backend={HTML5Backend}>
          {data &&
            data?.map((rowData, rowIndex) => (
              <>{renderCard(rowData, rowIndex, () => rowOnClick(rowData))}</>
            ))}
        </DndProvider>
        </>
  );
};
